import { useEffect, useState } from "react";
import { KinsaInitialContext, Patient } from "src/lib/definitions";
import { useInitialContext } from "@repo/sdk";
import { useVisitList } from "src/app/home/[flagCode]/components/hooks/use-visit-list";
import { filterToPatientVisits } from "src/lib/data";
import { determineCaseStatus } from "../lib/determineCaseStatus";

export const usePatientCaseStatus = (selectedPatient: Patient) => {
  const [patientCaseStatus, setPatientCaseStatus] = useState<string | null>(
    null
  );
  const [nextRoute, setNextRoute] = useState<string | null>(null);
  const [isCaseStatusLoading, setIsCaseStatusLoading] = useState(true);

  const initialContext = useInitialContext<KinsaInitialContext>();
  const { data: visits, isLoading: visitsLoading } = useVisitList();

  useEffect(() => {
    async function getCaseStatus() {
      setIsCaseStatusLoading(true);
      if (visits && initialContext) {
        const patientVisits = filterToPatientVisits(visits, selectedPatient);
        const { status, route } = await determineCaseStatus(
          patientVisits,
          initialContext
        );
        setPatientCaseStatus(status);
        setNextRoute(route);
      }
      setIsCaseStatusLoading(false);
    }
    getCaseStatus();
    // eslint-disable-next-line react-hooks/exhaustive-deps -- initialContext and visits are stable references that don't need to trigger re-renders
  }, [selectedPatient.id]);

  return {
    patientCaseStatus,
    nextRoute,
    isCaseStatusLoading,
    visitsLoading,
  };
};
